import { render, staticRenderFns } from "./petItem.vue?vue&type=template&id=7bfba167&"
import script from "./petItem.vue?vue&type=script&lang=js&"
export * from "./petItem.vue?vue&type=script&lang=js&"
import style0 from "./petItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports